<template lang="html">
  <div class="container-fluid unauthorized">
    <div id="formulario-top" class="container">
      <div class="signboard">
        <div class="circle"></div>
        <div class="left"></div>        
      </div>      
      <div class="back-button" @click="goBack()">VOLVER!</div>
      <div class="title">{{title.toUpperCase()}}</div>
      <div class="description">{{description.toUpperCase()}}</div>
      
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data() {
    return {
      title: '401 No autorizado',
      description: 'Usuario no autorizado para acceder a esta pagina',      
    }
  },
  watch: {    
  },
  methods: {
    goBack(){      
      this.$router.go(-2);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';
.container-fluid, .row {
  margin: 0;
  padding: 0;
}

.unauthorized {
  background-color: rgba(238, 158, 7, 0.95);
  height:100%;
  color: #fff;
  margin: auto;
  text-align: center;
  @include celphone{
      height: 100vh;
  }
  .title {
    margin: auto;
    text-align: center;
    display: block;
    font-size: 40px;
    font-weight: 700;
    width: 35%;
    margin-top: 25px;
    @include tablet {
      font-size: 25px;
    }
    @include celphone{
        width: 90%;
        font-size: 25px;
        margin-top: 15px;
    }
  }
  .description {
    text-align: center;    
    display: block;
    font-size: 15px;
    font-weight: 400;
    width: 35%;
    margin: auto;
    margin-top: 15px;
    @include celphone{
        width: 75%;
        font-size: 13px;
        margin-top: 5px;
    }
  }
  .back-button {
    padding: 30px;
    width: 35%;    
    font-size: 45px;
    font-weight: 300;
    background-color: #fff;
    color: rgba(238, 158, 7, 0.95);
    text-align: center;
    margin: auto;
    cursor: pointer;
    @include celphone{
        width: 70%;
    }
  }
  .back-button:hover {
    background-color: rgba(0,0,0,.87);
  }
  .signboard {
      margin: auto;
      width: 35%;
      height: 45vh;
      
      @include celphone{
        height: 25vh;
      }          
      .circle {
        margin: auto;        
        width: 35px;
        height: 35px;
        background-color: #fff;
        border-radius: 50%;
        @include celphone{
            margin: auto;
            width: 25px;
            height: 25px;
        } 
      }
      .left {
        border-right: 3px solid #fff;
        height: 41.5vh;
        width: 50%;
        @include celphone{
            height: 25.5vh;
        } 
      }     
  }

  #formulario-top {
    height: 100vh;
    margin-top: 120px;
    border-bottom: 1px solid $inactive;
    @include celphone{
      height: 45vh;
    }
  }

  #graficas {
    height: 75vh;
  }

  #buttons{
    display: block;
    margin-left: 0;    
    @include celphone{
      text-align: center;
    }
  }   
}
</style>





// WEBPACK FOOTER //
// Unauthorized.vue?76e460d6